// removed by extract-text-webpack-plugin
module.exports = {"header":"dQVS8_icuLB0aC7VzEfHc","textBox":"SSdAX2Mp13UxDPkmZp0TD","closeButton":"_1PNvJ-ffVAHD3CN8r14V5r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/Step2a.css
// module id = 1006
// module chunks = 0